/**
 * Created by mqamhieh on 6/14/18.
 */
(function () {

    "use strict";

    angular
        .module('userActivation')
        .controller("UserActivationSuccessModal", UserActivationSuccessModal);

    UserActivationSuccessModal.$inject = ['$scope', 'hUser'];

    function UserActivationSuccessModal($scope, hUser) {
        var self = this;

        self.showLogin = !hUser.isLoggedIn();

        self.close = function () {
            $scope.$hide();
        };
    }

})();
